import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import loginRight from "../assets/img/login-right.svg";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import calling from "../assets/img/Calling.svg";
import clock from "../assets/img/Time Circle.svg";
import mail from "../assets/img/Message.svg";
import axios from "axios";

const MLogin = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [contactSuccess, setContactSuccess] = useState("");
  const [contactError, setContactError] = useState("");
const [settings, setSettings] = useState({
  email: "",
  phone: "",
  responseTime: "",
});

useEffect(() => {
  const fetchSettings = async () => {
    try {
      const response = await axios.get("https://app.endorselearning.co.uk/api/setting");
      if (response.data.success) {
        const data = response.data.data;
        setSettings({
          email: data.Email || "",
          phone: data.Call || "",
          responseTime: data.responce_time || "",
        });
		
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  fetchSettings();
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setContactError("");
    setContactSuccess("");

    try {
      const response = await axios.post(
        "https://app.endorselearning.co.uk/api/contact",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setContactSuccess(response.data.message);
        setFormData({ name: "", email: "", phone: "", message: "" });
      }
    } catch (error) {
      setContactError("Failed to send message. Please try again.");
    }
  };

  return (
    <div>
      <BreadCrumb />
      <section className="login-page section-space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="login-box">
                <div className="row g-0">
                  <div className="col-lg-6">
                    <div className="login-left">
                      <h2 className="login-title">Contact Us</h2>
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label className="label-top">Name</label>
                          <input
                            className="form-control"
                            type="text"
                            name="name"
                            placeholder="Enter Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label className="label-top">Email ID</label>
                              <input
                                className="form-control"
                                type="email"
                                name="email"
                                placeholder="Enter Email ID"
                                value={formData.email}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="form-group">
                              <label className="label-top">Phone</label>
                              <input
                                className="form-control"
                                type="text"
                                name="phone"
                                placeholder="Enter Phone No."
                                value={formData.phone}
                                onChange={handleChange}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="label-top">Message</label>
                          <textarea
                            className="form-control"
                            name="message"
                            placeholder="Enter Your Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          ></textarea>
                        </div>
                        {contactSuccess && (
                          <p style={{ color: "green", marginTop: "10px" }}>{contactSuccess}</p>
                        )}
                        {contactError && (
                          <p style={{ color: "red", marginTop: "10px" }}>{contactError}</p>
                        )}
                        <div className="form-group text-center">
                          <button type="submit" className="btn btn-green">
                            Send Message
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="col-lg-6 d-flex">
                    <div className="login-right h-100 w-100 d-flex justify-content-center align-items-center">
                      <ul className="address-list list-unstyled">
                        <li><img src={calling} className='img-fluid' alt="" /> Tel :{settings.phone}</li>
                        <li><img src={clock} className='img-fluid' alt="" /> Response hours: {settings.responseTime}</li>
                        <li><img src={mail} className='img-fluid' alt="" /> Email: {settings.email}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MLogin;
